import {Bar} from 'vue-chartjs'

export default {
    extends: Bar,
    data() {
        return {
            query: '',
            stop: false,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                showTooltips: false,
                showInlineValues: true,
                centeredInllineValues: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                        categoryPercentage: 0.5,
                        barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            },
            pending: [],
            rejected: [],
            cancelled: [],
            approved: [],
            deleted: [],
            pax_cancelled: [],
            system_cancelled: [],
            labels: []
        }
    },
    methods: {
        newAction(label, pending, rejected, cancelled, approved, pax_cancelled = 0, system_cancelled = 0, deleted = 0) {
            if (this.query) {
                return;
            }
            let index = this.labels.findIndex(elem => elem === label);
            if (index !== -1) {
                if (pending !== 0) {
                    this.pending[index] += pending;
                }
                if (rejected !== 0) {
                    this.rejected[index] += rejected;
                }
                if (cancelled !== 0) {
                    this.cancelled[index] += cancelled;
                }
                if (approved !== 0) {
                    this.approved[index] += approved;
                }
                if (pax_cancelled !== 0) {
                    this.pax_cancelled[index] += pax_cancelled;
                }
                if (system_cancelled !== 0) {
                    this.system_cancelled[index] += system_cancelled;
                }
                if (deleted !== 0) {
                    this.deleted[index] += deleted;
                }
            } else {
                index = this.labels.findIndex(elem => elem > hour);
                if (index !== -1) {
                    this.labels.splice(index, 0, label);
                    this.pending.splice(index, 0, pending);
                    this.rejected.splice(index, 0, rejected);
                    this.cancelled.splice(index, 0, cancelled);
                    this.approved.splice(index, 0, approved);
                    this.pax_cancelled.splice(index, 0, pax_cancelled);
                    this.deleted.splice(index, 0, deleted);
                    this.system_cancelled.splice(index, 0, system_cancelled);
                } else {
                    this.labels.push(label);
                    this.pending.push(pending);
                    this.rejected.push(rejected);
                    this.cancelled.push(cancelled);
                    this.approved.push(approved);
                    this.pax_cancelled.push(pax_cancelled);
                    this.system_cancelled.push(system_cancelled);
                    this.deleted.push(deleted);
                }
            }
            this.render();
        },
        change() {
            this.stop = !this.stop;
            if (!this.stop) {
                this.update();
            }
        },
        render() {
            this.renderChart({
                labels: this.labels,
                datasets: [
                    {
                        type: 'bar',
                        label: 'Pending',
                        tooltipTemplate: 'ddd',
                        backgroundColor: '#8e71c7',
                        data: this.pending,
                    },
                    {
                        type: 'bar',
                        label: 'Deleted',
                        fill: false,
                        backgroundColor: '#ff8080',
                        data: this.deleted,
                    },
                    {
                        type: 'bar',
                        label: 'Rejected',
                        fill: false,
                        backgroundColor: 'red',
                        data: this.rejected,
                    },
                    {
                        type: 'bar',
                        label: 'Approved',
                        fill: false,
                        backgroundColor: 'green',
                        data: this.approved,
                    },
                    {
                        type: 'bar',
                        label: 'Cancelled',
                        fill: false,
                        backgroundColor: '#ff7600',
                        data: this.cancelled
                    },
                    {
                        type: 'bar',
                        label: 'Pax Cancelled',
                        fill: false,
                        backgroundColor: '#ff9940',
                        data: this.pax_cancelled
                    },
                    {
                        type: 'bar',
                        label: 'System Cancelled',
                        fill: false,
                        backgroundColor: '#ad6221',
                        data: this.system_cancelled
                    }
                ]
            }, this.options);
        },
        init(data) {
            this.labels = [];
            this.pending = [];
            this.rejected = [];
            this.cancelled = [];
            this.approved = [];
            this.pax_cancelled = [];
            this.deleted = [];
            this.system_cancelled = [];
            data.forEach(e => {
                this.labels.push(Number.parseInt(e.hour));
                this.pending.push(Number.parseInt(e.pending));
                this.rejected.push(Number.parseInt(e.rejected));
                this.cancelled.push(Number.parseInt(e.cancelled));
                this.approved.push(Number.parseInt(e.approved));
                this.pax_cancelled.push(Number.parseInt(e.pax_cancelled));
                this.deleted.push(Number.parseInt(e.deleted));
                this.system_cancelled.push(Number.parseInt(e.system_cancelled));
            });
            this.render();
        }
    }
};